import axios from "axios";

const instance = axios.create({
    baseURL: "https://suitecodes-63faa-default-rtdb.firebaseio.com/"
});

export default instance;